var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"planning-view"},[_c('planning',{attrs:{"adils":_vm.adils || [],"permanences":_vm.permanences || [],"hours":_vm.hours,"date":_vm.currentDate},on:{"next":_vm.dayNext,"prev":_vm.dayBefore,"refresh":_vm.refreshList,"date-changed":_vm.changeDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }